import React from "react";

import { HubDialogWrapper } from "../HubDialogWrapper";
import CreateLaborContent from "./CreateLaborContent";

export const CreateLaborDialog = () => {
  return (
    <HubDialogWrapper
      maxWidth="sm"
      name="create-labor-ticket"
      sx={{ ".MuiPaper-root": { overflow: "visible" } }}
    >
      <CreateLaborContent />
    </HubDialogWrapper>
  );
};

export default CreateLaborDialog;
